module.exports = __webpack_public_path__ + "static/media/chandizhengshenqingliucheng3.87c1311d.png";